<template>
  <div>
    <h2>リスト</h2>
    <template v-for="id in store.state.list.ids" v-bind:key="id">
      <SongCard :songId="id" />
    </template>
    <router-link :to="{ name: 'Home' }">
      <ListButton icon="search" />
    </router-link>
    <div class="saveButton" v-if="exist">
      <router-link :to="{ name: 'SaveList' }"><h4>save</h4></router-link>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useStore } from "vuex";
import SongCard from "@/components/SongCard.vue";
import ListButton from "@/components/ListButton.vue";

export default defineComponent({
  name: "List",
  components: { SongCard, ListButton },
  setup() {
    const store = useStore();
    return { store };
  },
  computed: {
    exist() {
      return this.store.state.list.ids.length != 0;
    },
  },
});
</script>

<style scoped>
.saveButton {
  color: white;
  text-decoration: none;
  width: 160px;
  height: 40px;
  background-color: #555;
  border-radius: 10px;
  line-height: 40px;
  margin: auto;
  margin-top: 30px;
}
a {
  text-decoration: none;
  color: white;
}
</style>
